<template>
  <div>
    <DashboardHeader />
    <router-view v-if="customer" />
  </div>
</template>
<script>
import DashboardHeader from "@/components/DashboardComponents/DashboardHeader";
import api from "@/api";
import { mapActions, mapState } from "vuex";
export default {
  name: "Dashboard",
  components: {
    DashboardHeader,
  },
  data() {
    return {
      loadingMap: true,
    };
  },
  async mounted() {
    await this.$store.dispatch("customer");
    this.setCulqiCustomer();
    this.$store.dispatch("loadZones");
    await this.$nextTick();
    await this.getApiKey(this.customer.id);
  },
  computed: {
    ...mapState(["apiKey", "customer"]),
  },
  methods: {
    ...mapActions(["getApiKey"]),
    setCulqiCustomer() {
      const { apikey } = this.apiKey;
      this.$store
        .dispatch("checkCulqi", { customer: this.customer, apiKey: apikey })
        .then(() => {
          if (this.customer) {
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              type: "success",
              title: "Cuenta Verificada",
            });
          } else {
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              type: "error",
              title: "Ocurrió un error, por favor intente nuevamente.",
            });
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
